var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.getClass(_vm.type)},[_c('md-icon',{class:_vm.getIconClass(_vm.type)},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }